import script from "./Manage.vue?vue&type=script&setup=true&lang=ts"
export * from "./Manage.vue?vue&type=script&setup=true&lang=ts"

import "./Manage.vue?vue&type=style&index=0&id=595b2a0e&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595b2a0e"]])

export default __exports__